import React from 'react';
import PropTypes from 'prop-types';
import { LessonNavigation } from '@ramsey-plus-components/learn-ui';

const LessonNavigationContainer = ({ navigation, item }) => {
  return <LessonNavigation navigation={navigation} item={item} />;
};

LessonNavigationContainer.propTypes = {
  navigation: PropTypes.object,
  item: PropTypes.object
};

export default LessonNavigationContainer;
